/* TCC desktopmenu (okt 2026, optie B). Vanaf 990px: knoppen "Shop" en "Hulp & info" in de header
   (het sectiescript zet ze er al vóór de eerste weergave in), panelen eronder.
   Openen: hover met korte vertraging, klik, of toetsenbord (Enter/Spatie/pijl omlaag). Sluiten: muis weg,
   Esc, klik ernaast, scrollen waarbij de header wegschuift, of smaller dan 990px.
   Meting: zelfde events als het mobiele menu (menu_open, menu_click) met menu_layout = desktop. */
(() => {
  if (customElements.get('tcc-desktop-menu')) return;
  const MQ = window.matchMedia('(min-width: 990px)');
  const HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
  const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const OPEN_DELAY = 120, SWITCH_DELAY = 40, CLOSE_DELAY = 220;

  function track(name, params) {
    const p = Object.assign({ menu_layout: 'desktop' }, params || {});
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    try { if (typeof window.clarity === 'function') { window.clarity('event', name); if (p.menu_section) window.clarity('set', 'menu_section', p.menu_section); } } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('tcc:menu', { detail: Object.assign({ event: name }, p) })); } catch (e) {}
  }

  class TccDesktopMenu extends HTMLElement {
    connectedCallback() {
      this.host = document.querySelector('.header__inline-menu');
      // het sectiescript heeft de knoppen al verplaatst; na een herlaad in de editor staan ze nog hier
      const fresh = this.querySelector('.tcc-dm__nav');
      if (fresh && this.host) {
        this.host.querySelectorAll('.tcc-dm__nav').forEach(old => old.remove());
        this.host.insertBefore(fresh, this.host.firstChild);
        this.host.classList.add('tcc-dm-host');
        fresh.hidden = false;
      }
      this.nav = this.host ? this.host.querySelector('.tcc-dm__nav') : null;
      if (!this.nav) return; // geen header gevonden: het themamenu blijft staan
      this.dim = this.querySelector('.tcc-dm__dim');
      this.panels = {};
      this.querySelectorAll('[data-tcc-dm-panel]').forEach(p => { this.panels[p.dataset.tccDmPanel] = p; });
      this.buttons = {};
      this.nav.querySelectorAll('[data-tcc-dm-open]').forEach(b => { this.buttons[b.dataset.tccDmOpen] = b; });
      this.cur = null; this.openedAt = 0; this.tOpen = 0; this.tClose = 0;

      this.onKey = this.onKey.bind(this);
      this.onDocPointer = this.onDocPointer.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = () => { if (this.cur) this.place(); };
      this.onMq = () => { if (!MQ.matches) this.close(true); };
      this.onPageShow = e => { if (e.persisted) this.close(true); };

      Object.entries(this.buttons).forEach(([key, b]) => {
        b.addEventListener('mouseenter', () => {
          if (!HOVER.matches || !MQ.matches) return;
          this.warm();
          clearTimeout(this.tClose); clearTimeout(this.tOpen);
          this.tOpen = setTimeout(() => this.open(key, 'hover'), this.cur ? SWITCH_DELAY : OPEN_DELAY);
        });
        b.addEventListener('mouseleave', () => { if (!HOVER.matches) return; clearTimeout(this.tOpen); this.scheduleClose(); });
        b.addEventListener('click', e => {
          clearTimeout(this.tOpen);
          // net via hover geopend: een klik laat hem open in plaats van hem meteen weer te sluiten
          if (this.cur === key && Date.now() - this.openedAt > 450) { this.close(); return; }
          this.open(key, e.detail === 0 ? 'key' : 'click');
          if (e.detail === 0) this.focusFirst(key);
        });
        b.addEventListener('keydown', e => {
          if (e.key === 'ArrowDown') { e.preventDefault(); this.open(key, 'key'); this.focusFirst(key); }
        });
      });
      Object.values(this.panels).forEach(p => {
        p.addEventListener('mouseenter', () => { clearTimeout(this.tClose); });
        p.addEventListener('mouseleave', () => { if (HOVER.matches) this.scheduleClose(); });
        p.addEventListener('click', e => this.onPanelClick(e));
        p.addEventListener('keydown', e => this.onPanelKey(e, p));
      });
      if (this.dim) this.dim.addEventListener('click', () => this.close());
      this.nav.addEventListener('pointerenter', () => this.warm(), { passive: true });

      window.addEventListener('pageshow', this.onPageShow);
      if (MQ.addEventListener) MQ.addEventListener('change', this.onMq);
      // beelden alvast laden als de pagina klaar is (alleen desktop), zodat het menu meteen compleet opent
      const idle = cb => (window.requestIdleCallback ? window.requestIdleCallback(cb, { timeout: 3000 }) : setTimeout(cb, 200));
      const later = () => setTimeout(() => idle(() => { if (MQ.matches) this.warm(); }), 2500);
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
      if (window.Shopify && window.Shopify.designMode) this.bindEditor();
    }

    disconnectedCallback() {
      this.unbindOpen();
      window.removeEventListener('pageshow', this.onPageShow);
      if (MQ.removeEventListener) MQ.removeEventListener('change', this.onMq);
      // sectie weg (bijv. uitgezet in de editor): knoppen weghalen, themamenu terug
      if (!this.isConnected && this.nav && this.nav.isConnected) {
        this.nav.remove();
        if (this.host && !this.host.querySelector('.tcc-dm__nav')) this.host.classList.remove('tcc-dm-host');
      }
    }

    warm() {
      if (this.warmed) return;
      this.warmed = true;
      this.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
    }

    // panelen precies onder de header en op de breedte van de headerinhoud
    place() {
      const section = document.querySelector('.section-header') || document.querySelector('sticky-header') || this.host;
      const inner = document.querySelector('header.header') || this.host;
      const r = section.getBoundingClientRect(), ir = inner.getBoundingClientRect(), cs = getComputedStyle(inner);
      const pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
      this.style.setProperty('--tcc-dm-top', Math.max(0, Math.round(r.bottom)) + 'px');
      this.style.setProperty('--tcc-dm-left', Math.round(ir.left + pl) + 'px');
      this.style.setProperty('--tcc-dm-width', Math.round(ir.width - pl - pr) + 'px');
      const hb = this.buttons.help;
      if (hb) {
        const br = hb.getBoundingClientRect();
        const maxLeft = Math.round(ir.right - pr - 420);
        this.style.setProperty('--tcc-dm-help-left', Math.min(Math.round(br.left - 8), maxLeft) + 'px');
      }
    }

    scheduleClose() {
      clearTimeout(this.tClose);
      this.tClose = setTimeout(() => this.close(), CLOSE_DELAY);
    }

    open(key, how) {
      const panel = this.panels[key];
      if (!panel || !MQ.matches) return;
      clearTimeout(this.tClose);
      if (this.cur === key) return;
      const switching = !!this.cur;
      if (this.cur) this.hide(this.cur);
      this.warm();
      this.place();
      this.cur = key; this.openedAt = Date.now();
      panel.inert = false;
      panel.classList.add('is-on');
      this.classList.add('is-open');
      document.documentElement.classList.add('tcc-dm-open');
      this.buttons[key].setAttribute('aria-expanded', 'true');
      if (!switching) this.bindOpen();
      track('menu_open', { menu_panel: key, menu_trigger: how || '' });
    }

    hide(key) {
      const panel = this.panels[key];
      if (panel) { panel.classList.remove('is-on'); panel.inert = true; panel.scrollTop = 0; }
      if (this.buttons[key]) this.buttons[key].setAttribute('aria-expanded', 'false');
    }

    close(instant, focusButton) {
      clearTimeout(this.tOpen); clearTimeout(this.tClose);
      if (!this.cur) return;
      const key = this.cur;
      if (instant) this.classList.add('tcc-dm--instant');
      this.hide(key);
      this.cur = null;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('tcc-dm-open');
      this.unbindOpen();
      if (focusButton && this.buttons[key]) this.buttons[key].focus({ preventScroll: true });
      if (instant) requestAnimationFrame(() => this.classList.remove('tcc-dm--instant'));
    }

    bindOpen() {
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('pointerdown', this.onDocPointer, true);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
    }

    unbindOpen() {
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('pointerdown', this.onDocPointer, true);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    onDocPointer(e) {
      const t = e.target;
      if (!t || !t.closest) return;
      if (this.nav.contains(t) || t.closest('.tcc-dm__panel')) return;
      if (t.closest('.tcc-dm__dim')) return; // de klik op de dim sluit zelf
      this.close(true);
    }

    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        if (!this.cur) return;
        const section = document.querySelector('.section-header');
        if (section && section.classList.contains('shopify-section-header-hidden')) { this.close(true); return; }
        this.place();
      });
    }

    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(false, true); }
    }

    focusFirst(key) {
      const panel = this.panels[key];
      if (!panel) return;
      setTimeout(() => { const f = panel.querySelector(FOCUSABLE); if (f) f.focus({ preventScroll: true }); }, 30);
    }

    // Tab voorbij de laatste link: verder naar het volgende element in de header; Shift+Tab bij de eerste: terug naar de knop
    onPanelKey(e, panel) {
      if (e.key !== 'Tab') return;
      const items = [...panel.querySelectorAll(FOCUSABLE)].filter(el => el.offsetParent !== null);
      if (!items.length) return;
      const key = panel.dataset.tccDmPanel;
      if (e.shiftKey && document.activeElement === items[0]) {
        e.preventDefault(); this.buttons[key].focus({ preventScroll: true });
      } else if (!e.shiftKey && document.activeElement === items[items.length - 1]) {
        e.preventDefault();
        const order = Object.keys(this.buttons);
        const next = this.buttons[order[order.indexOf(key) + 1]] || document.querySelector('#cart-icon-bubble');
        this.close(true);
        if (next) next.focus({ preventScroll: true });
      }
    }

    onPanelClick(e) {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const label = (a.getAttribute('aria-label') || a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
      track('menu_click', { link_text: label, link_url: a.href, menu_section: a.dataset.tccSec || '' });
    }

    // themaeditor: sectie of blok selecteren op desktopbreedte toont het menu
    bindEditor() {
      const mine = e => e.target && (e.target.contains(this) || (e.target.closest && e.target.closest('.shopify-section') && e.target.closest('.shopify-section').contains(this)));
      document.addEventListener('shopify:section:select', e => { if (mine(e) && MQ.matches) this.open('shop', 'editor'); });
      document.addEventListener('shopify:section:deselect', e => { if (mine(e)) this.close(true); });
      document.addEventListener('shopify:block:select', e => {
        if (!MQ.matches) return;
        const sec = this.closest('.shopify-section');
        if (!sec || !sec.contains(e.target)) return;
        this.open(e.target.closest('.tcc-mm__help, [data-tcc-type="help"]') ? 'help' : 'shop', 'editor');
      });
    }
  }
  customElements.define('tcc-desktop-menu', TccDesktopMenu);
})();
